/**
 * モジュール読み込み
 */
import { Header } from './modules/layout/Header';
import { HeaderFixed } from './modules/layout/HeaderFixed';
import { Initialize } from './modules/utility/Initialize';
import { Intro } from './modules/animation/Intro';
import { Inview } from './modules/animation/Inview';
import { ModalPopup } from './modules/widget/ModalPopup';
import { PageTop } from './modules/scroll/PageTop';
import { SmoothScroll } from './modules/scroll/SmoothScroll';
import { Accordion } from './modules/animation/Accordion';
import { FacilityFloorMap } from './modules/widget/FacilityFloorMap';
import { SlickSlider } from './modules/widget/SlickSlider';
import { ReceiptSeat } from './modules/receipt/ReceiptSeat';

require('jquery.easing');

/**
 * 実行クラス
 */
new (class Main {
  /**
   * コンストラクタ
   */
  constructor() {
    /**
     * HTML要素にクラス名を追加 (先頭に記述)
     */
    new Initialize(false, '1020');

    /**
     * ヘッダー
     */
    new Header('.fn-header');

    /**
     * ヘッダー追従制御
     */
    new HeaderFixed('.fn-header');

    /**
     * ページトップ
     */
    new PageTop('.fn-pageTop');

    /**
     * イントロアニメーション
     */
    new Intro('.fn-intro', [
      {
        delay: 0,
        stay: 500,
        callable: (): void => {
          $('.fn-intro').addClass('is-1st');
        }
      },
      {
        delay: 0,
        stay: 1000,
        callable: (): void => {
          $('.fn-intro').addClass('is-2nd');
        }
      },
      {
        delay: 0,
        stay: 200,
        callable: (): void => {
          $('.fn-intro').addClass('is-3nd');
        }
      },
      {
        delay: 0,
        stay: 500,
        callable: (): void => {
          $('.fn-intro').addClass('is-4nd');
        }
      },
      {
        delay: 0,
        stay: 500,
        callable: (): void => {
          $('.fn-intro').addClass('is-last');
        }
      }
    ]);

    /**
     * アコーディオン
     */
    new Accordion(".fn-accordion", 1000);

    /**
     * ページ内リンク
     */
    new SmoothScroll('.fn-smoothScroll:not(.fn-pageTop)');

    /**
     * モーダル
     */
    new ModalPopup('.fn-modalPopup');

    /**
     * inviewスクロールアニメーション
     */
    new Inview('.fn-inview', 0);

    /**
     * 施設案内フロアマップ
     * (2Fフロアマップのホバー、モーダル開閉時のSlick連動)
     */
    new FacilityFloorMap();

    /**
     * TOPの新着情報Slickスライダー
     */
    new SlickSlider('.fn-newsSlider', {
      autoplay: true,
      arrows: false,
      easing: 'ease'
    });

    /**
     * Top残席表示表文言
     */
    new ReceiptSeat('.fn-receiptSeat');
  }
})();
